import { ISobCompetitor } from 'partner360/models/ISobCompetitor'

import { ICompetitorsSobChangeLog } from '../../../models/competitorsSob/ICompetitorsSobChangeLog'
import { PREV_PREV_YEAR_PREFIX } from '../constants'

const fieldsForCheck: (keyof ISobCompetitor)[] = [
  'CurrentYearQ1ActualsSob',
  'CurrentYearQ1ActualsSob',
  'CurrentYearQ3ActualsSob',
  'CurrentYearQ4ActualsSob',
  'PrevYearQ1ActualsSob',
  'PrevYearQ2ActualsSob',
  'PrevYearQ3ActualsSob',
  'PrevYearQ4ActualsSob',
]
const roundToDecimalPlaces = (value: number, decimalPlaces: number): number => {
  const factor = Math.pow(10, decimalPlaces)
  return Math.round(value * factor) / factor
}

const roundSecondNumberBasedOnFirst = (first: number, second: number): number => {
  const firstString = first.toString()
  const decimalPlaces = firstString.includes('.') ? firstString.split('.')[1].length : 0

  return roundToDecimalPlaces(second, decimalPlaces)
}

const isFieldChanged = (
  newValue: number | null | string | undefined,
  oldValue: number | null | string | undefined
): boolean => {
  if (!newValue && !oldValue) {
    return false
  }

  if (typeof newValue === 'number' && typeof oldValue === 'number') {
    const newValueRounded = roundSecondNumberBasedOnFirst(oldValue, newValue)
    return Math.round(newValueRounded ?? 0) !== Math.round(oldValue ?? 0)
  }

  return newValue !== oldValue
}

export const findChanges = (
  data: ISobCompetitor[],
  initialData: ISobCompetitor[]
): ICompetitorsSobChangeLog[] => {
  return data.reduce<ICompetitorsSobChangeLog[]>((changes, newItem) => {
    const oldItem = initialData.find(
      (item) => item.EntryId === newItem.EntryId && item.CompetitorID === newItem.CompetitorID
    )

    if (!oldItem) {
      return changes
    }

    const changedFields = Object.keys(newItem).filter((key) => {
      if (
        key === 'EntryId' ||
        key === 'CompetitorID' ||
        key.startsWith(PREV_PREV_YEAR_PREFIX) ||
        !fieldsForCheck.includes(key as keyof ISobCompetitor)
      ) {
        return false
      }
      return isFieldChanged(newItem[key], oldItem[key])
    })

    if (changedFields.length > 0) {
      changes.push({
        EntryId: newItem.EntryId,
        CompetitorID: newItem.CompetitorID,
        changedFields,
      })
    }

    return changes
  }, [])
}
